var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoFriend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 2.31389C70.1107 2.31389 89.6862 21.9356 89.6862 46C89.6862 70.0645 70.0644 89.6862 46 89.6862C21.9356 89.6862 2.31388 70.0645 2.31388 46C2.31388 21.9356 21.9356 2.31389 46 2.31389ZM46 0C20.5936 0 0 20.5936 0 46C0 71.4065 20.5936 92.0001 46 92.0001C71.4065 92.0001 92.0001 71.4065 92.0001 46C92.0464 20.5936 71.4528 0 46 0Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 88.0202C69.207 88.0202 88.02 69.2071 88.02 46C88.02 22.7929 69.207 3.97986 45.9999 3.97986C22.7928 3.97986 3.97974 22.7929 3.97974 46C3.97974 69.2071 22.7928 88.0202 45.9999 88.0202Z",
    fill: "url(#paint0_radial_702_8268)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7937 45.3711H48.3738C55.4445 45.3711 61.1676 51.1031 61.1676 58.1648V61.8125C61.1676 64.7953 58.7508 67.2211 55.759 67.2211H32.3996C29.4168 67.2121 27 64.7953 27 61.8125V58.1648C27 51.0941 32.732 45.3711 39.7937 45.3711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0882 42.9902C49.1147 42.9902 53.1894 38.9155 53.1894 33.889C53.1894 28.8626 49.1147 24.7878 44.0882 24.7878C39.0618 24.7878 34.9871 28.8626 34.9871 33.889C34.9871 38.9155 39.0618 42.9902 44.0882 42.9902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4195 41.6809L67.3358 39.5971L69.4195 37.5134C70.4297 36.5033 70.4297 34.8642 69.4195 33.8541C68.4094 32.844 66.7704 32.844 65.7603 33.8541L63.6765 35.9379L61.5928 33.8541C60.5826 32.844 58.9436 32.844 57.9335 33.8541C56.9234 34.8642 56.9234 36.5033 57.9335 37.5134L60.0172 39.5971L57.9335 41.6809C56.9234 42.691 56.9234 44.3301 57.9335 45.3402C58.9436 46.3503 60.5826 46.3503 61.5928 45.3402L63.6765 43.2564L65.7603 45.3402C66.7704 46.3503 68.4094 46.3503 69.4195 45.3402C70.4297 44.3301 70.4297 42.691 69.4195 41.6809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_702_8268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9999 46) rotate(-90) scale(42.0202 41.5124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_8268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(27 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoFriend);
export default __webpack_public_path__ + "static/media/icon_no_friend.2342650f44aa1595653cc8b03abaceb3.svg";
export { ForwardRef as ReactComponent };